(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-defilants"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('avis-defilants-piste')) return;

    class AvisDefilantsPiste extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.avis-defilants__rail');
        if (!this.rail) return;
        this.build();
        this.resizeObserver = new ResizeObserver(() => this.setDuration());
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      build() {
        this.rail.querySelectorAll('[data-copie]').forEach((el) => el.remove());
        const groupe = this.rail.querySelector('.avis-defilants__groupe');
        if (!groupe || groupe.children.length === 0) return;
        const copie = groupe.cloneNode(true);
        copie.setAttribute('data-copie', '');
        copie.setAttribute('aria-hidden', 'true');
        copie.setAttribute('inert', '');
        copie.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        this.rail.appendChild(copie);
        this.setDuration();
      }

      setDuration() {
        const groupe = this.rail.querySelector('.avis-defilants__groupe');
        if (!groupe) return;
        const vitesse = Number(getComputedStyle(this).getPropertyValue('--avis-vitesse')) || 40;
        const secondes = Math.max(groupe.scrollWidth / vitesse, 10);
        this.style.setProperty('--avis-duree', secondes + 's');
      }
    }

    customElements.define('avis-defilants-piste', AvisDefilantsPiste);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('avis-defilants-piste').forEach((el) => el.build && el.build());
    });
    document.addEventListener('shopify:block:select', (event) => {
      const piste = event.target.closest && event.target.closest('avis-defilants-piste');
      if (piste) piste.classList.add('avis-defilants__piste--pause');
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const piste = event.target.closest && event.target.closest('avis-defilants-piste');
      if (piste) piste.classList.remove('avis-defilants__piste--pause');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mur-stickers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mur-stickers')) {
    customElements.define(
      'mur-stickers',
      class extends HTMLElement {
        connectedCallback() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;
          // Déjà à l'écran au chargement : pas d'animation, on n'a rien à cacher
          const r = this.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.85 && r.bottom > 0) return;
          this.classList.add('is-attente');
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((e) => e.isIntersecting)) return;
              this.classList.remove('is-attente');
              this.classList.add('is-visible');
              this.observer.disconnect();
            },
            { threshold: 0.25 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tringle-vetements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tringle-vetements')) {
    class TringleVetements extends HTMLElement {
      connectedCallback() {
        this.scene = this.querySelector('[data-scene]');
        this.focus = this.querySelector('[data-focus]');
        this.visuel = this.querySelector('[data-visuel]');
        this.media = this.querySelector('[data-media]');
        this.img = this.querySelector('[data-focus-img]');
        this.items = Array.from(this.querySelectorAll('.tringle__cintre'));
        this.index = -1;
        this.cote = 'face';
        this.busy = false;
        this.reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.texteBouton = this.querySelector('[data-focus-lien-texte]').textContent;
        if (!this.items.length) return;

        this.items.forEach((el, i) => {
          el.addEventListener('click', (e) => {
            if (e.metaKey || e.ctrlKey || e.shiftKey) return;
            e.preventDefault();
            this.ouvrir(i);
          });
          el.addEventListener('pointerenter', () => this.precharger(el), { once: true });
          el.addEventListener('focus', () => this.precharger(el), { once: true });
        });

        this.querySelector('[data-fermer]').addEventListener('click', (e) => this.fermer(e.detail === 0));
        this.querySelector('[data-prec]').addEventListener('click', () => this.aller(-1));
        this.querySelector('[data-suiv]').addEventListener('click', () => this.aller(1));
        this.querySelectorAll('[data-cote-btn]').forEach((b) =>
          b.addEventListener('click', () => this.retourner(b.dataset.coteBtn))
        );

        // Clic dans le vide autour du t-shirt = retour à la tringle
        this.focus.addEventListener('click', (e) => {
          if (e.target === this.focus || e.target.classList.contains('tringle__focus-corps')) this.fermer();
        });

        this.onKey = (e) => {
          if (this.index < 0) return;
          if (e.key === 'Escape') this.fermer(true);
          else if (e.key === 'ArrowLeft') this.aller(-1);
          else if (e.key === 'ArrowRight') this.aller(1);
        };
        document.addEventListener('keydown', this.onKey);

        // Balayage gauche / droite sur mobile
        let x0 = null;
        this.focus.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
        this.focus.addEventListener(
          'touchend',
          (e) => {
            if (x0 === null) return;
            const dx = e.changedTouches[0].clientX - x0;
            x0 = null;
            if (Math.abs(dx) > 50) this.aller(dx < 0 ? 1 : -1);
          },
          { passive: true }
        );
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
      }

      precharger(el) {
        [el.dataset.face, el.dataset.dos].forEach((src) => {
          if (src) new Image().src = src;
        });
      }

      source(el, cote) {
        const d = el.dataset;
        return cote === 'dos' && d.dos ? { src: d.dos, r: d.rDos } : { src: d.face, r: d.rFace };
      }

      async afficher(el, cote) {
        const { src, r } = this.source(el, cote);
        this.visuel.style.setProperty('--r-focus', r);
        this.img.src = src;
        try {
          await this.img.decode();
        } catch (e) {}
      }

      remplir(el) {
        const d = el.dataset;
        this.querySelector('[data-focus-nom]').textContent = d.nom;
        const prix = this.querySelector('[data-etiquette-prix]');
        const epuise = d.dispo !== '1' || !d.montant;
        this.querySelector('[data-etiquette-montant]').textContent = epuise ? (d.dispo !== '1' ? 'ÉPUISÉ' : '') : d.montant;
        this.querySelector('[data-etiquette-devise]').textContent = epuise ? '' : d.devise;
        prix.classList.toggle('tringle__prix--epuise', d.dispo !== '1');
        prix.classList.toggle('tringle__prix--long', !epuise && d.montant.length > 3);
        this.querySelector('[data-etiquette-des]').hidden = epuise || d.des !== '1';
        this.querySelector('[data-etiquette-tailles]').textContent = d.tailles || '';
        this.querySelector('[data-focus-lien]').href = el.getAttribute('href');
        this.querySelector('[data-focus-lien-texte]').textContent = d.dispo === '1' ? this.texteBouton : 'Voir le t-shirt';
        this.img.alt = d.nom;
        const aDeuxCotes = d.dos && d.face && d.dos !== d.face;
        this.querySelectorAll('[data-cote-btn]').forEach((b) => (b.disabled = !aDeuxCotes));
        this.majBoutons();
      }

      majBoutons() {
        this.querySelectorAll('[data-cote-btn]').forEach((b) =>
          b.setAttribute('aria-pressed', String(b.dataset.coteBtn === this.cote))
        );
      }

      // Cache / réaffiche un t-shirt de la tringle sans fondu (évite qu'il apparaisse en double)
      basculer(li, actif) {
        li.style.transition = 'none';
        li.classList.toggle('is-active', actif);
        li.offsetWidth;
        li.style.transition = '';
      }

      async ouvrir(i) {
        if (this.busy || this.index === i) return;
        this.busy = true;
        const el = this.items[i];
        const depart = el.querySelector('img').getBoundingClientRect();
        this.index = i;
        this.cote = el.dataset.cote || 'face';
        this.remplir(el);
        await this.afficher(el, this.cote);

        this.focus.hidden = false;
        this.scene.classList.add('is-open');
        this.basculer(el.parentElement, true);

        if (!this.reduit) {
          const arrivee = this.media.getBoundingClientRect();
          const s = depart.height / arrivee.height;
          await this.media.animate(
            [
              { transform: `translate(${depart.left - arrivee.left}px, ${depart.top - arrivee.top}px) scale(${s})` },
              { transform: 'none' },
            ],
            { duration: 560, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
          ).finished;
        }
        this.querySelector('[data-fermer]').focus({ preventScroll: true });
        this.busy = false;
      }

      async fermer(auClavier = false) {
        if (this.busy || this.index < 0) return;
        this.busy = true;
        this.focus.classList.add('is-closing');
        const el = this.items[this.index];
        const li = el.parentElement;

        // Revenir sur le côté accroché à la tringle avant de repartir
        const coteRail = el.dataset.cote || 'face';
        if (this.cote !== coteRail) {
          this.cote = coteRail;
          await this.afficher(el, coteRail);
        }

        if (!this.reduit) {
          const arrivee = el.querySelector('img').getBoundingClientRect();
          const depart = this.media.getBoundingClientRect();
          const s = arrivee.height / depart.height;
          this.scene.classList.remove('is-open');
          await this.media.animate(
            [
              { transform: 'none' },
              { transform: `translate(${arrivee.left - depart.left}px, ${arrivee.top - depart.top}px) scale(${s})` },
            ],
            { duration: 460, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
          ).finished;
        } else {
          this.scene.classList.remove('is-open');
        }

        this.focus.hidden = true;
        this.focus.classList.remove('is-closing');
        this.basculer(li, false);
        this.index = -1;
        if (auClavier) el.focus({ preventScroll: true });
        this.busy = false;
      }

      async aller(sens) {
        if (this.busy || this.index < 0) return;
        this.busy = true;
        const n = this.items.length;
        const ancien = this.items[this.index].parentElement;
        this.index = (this.index + sens + n) % n;
        const el = this.items[this.index];

        if (!this.reduit) {
          await this.media.animate(
            [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: `translateX(${-sens * 40}px)` }],
            { duration: 180, easing: 'ease-in' }
          ).finished;
        }
        this.cote = el.dataset.cote || 'face';
        this.remplir(el);
        await this.afficher(el, this.cote);
        this.basculer(ancien, false);
        this.basculer(el.parentElement, true);

        if (!this.reduit) {
          await this.media.animate(
            [{ opacity: 0, transform: `translateX(${sens * 40}px)` }, { opacity: 1, transform: 'none' }],
            { duration: 260, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
          ).finished;
        }
        this.busy = false;
      }

      async retourner(cote) {
        if (this.busy || this.index < 0 || cote === this.cote) return;
        const el = this.items[this.index];
        const { src } = this.source(el, cote);
        if (!src) return;
        this.busy = true;
        this.cote = cote;
        this.majBoutons();
        const pret = new Image();
        pret.src = src;
        try {
          await pret.decode();
        } catch (e) {}

        if (this.reduit) {
          await this.afficher(el, cote);
        } else {
          const sens = cote === 'dos' ? 1 : -1;
          await this.img.animate([{ transform: 'rotateY(0deg)' }, { transform: `rotateY(${90 * sens}deg)` }], {
            duration: 220,
            easing: 'ease-in',
          }).finished;
          await this.afficher(el, cote);
          await this.img.animate([{ transform: `rotateY(${-90 * sens}deg)` }, { transform: 'rotateY(0deg)' }], {
            duration: 300,
            easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
          }).finished;
        }
        this.busy = false;
      }
    }

    customElements.define('tringle-vetements', TringleVetements);
  }

  } catch(e) { console.error(e); }
})();
})();
